import { HelmetProvider } from 'react-helmet-async'
import { routes } from './pages/routes'
import { Router } from './components/routing/router'
import './App.css'
import { ReactElement, useEffect, useState } from 'react'
import { SentryInit } from './services/sentry'
import { once } from 'lodash'

export default function App(): ReactElement {
    const [setupCompleted, setSetupcomplete] = useState(false)
    useEffect(() => {
        const setupFunctions = once(async () => {
            SentryInit()
            setSetupcomplete(true)
        })
        if (!setupCompleted) {
            setupFunctions()
        }
    }, [setupCompleted])

    return (
        <HelmetProvider>
            <Router routes={routes} />
        </HelmetProvider>
    )
}
